import { render, staticRenderFns } from "./ConversationBox.vue?vue&type=template&id=baff1996&scoped=true&"
import script from "./ConversationBox.vue?vue&type=script&lang=js&"
export * from "./ConversationBox.vue?vue&type=script&lang=js&"
import style0 from "./ConversationBox.vue?vue&type=style&index=0&id=baff1996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baff1996",
  null
  
)

export default component.exports